<template>
  <div>
    <div>
      <router-view></router-view>
    </div>
    <div v-if="this.$route.name==='CLOListPage' ">
      <section id="basic-datatable">
        <div class="row">
          <div class="col-12">
            <div class="text-right">
              <button type="button" class="btn btn-primary  mb-1" @click="addOrganisationPopup">
                <iconify-icon icon="ic:baseline-plus" height="22px"
                              style="transform: translate(5px, 5px);"></iconify-icon>
                <span class=" ml-25">{{ $t('listing_organisation_add_organisation_button') }}</span>
              </button>
            </div>
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h5 class="card-title titleColor">{{ $t('listing_organisation_heading') }}</h5>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li class="listSize">
                        <legend>
                          <select class="form-control mr-1" v-model="statusFilter" @change="filterByData">

                            <option value="default">{{
                                $t('listing_organisation_status_filter_all')
                              }}
                            </option>
                            <option value="joined"> {{
                                $t('listing_organisation_status_filter_active_status')
                              }}
                            </option>
                            <option value="banned"> {{
                                $t('listing_organisation_status_filter_inactive_status')
                              }}
                            </option>
                          </select>
                        </legend>
                      </li>
                      <li class="listSize ml-1">
                        <legend class="has-icon-left">
                          <select class="form-control mr-1" v-model="searchByCountryFilter" @change="filterByData">
                            <option value="default">
                              {{ $t('listing_organisation_all_country_default') }}
                            </option>
                            <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                                countryName(country)
                              }}
                            </option>
                          </select>
                          <div class="form-control-position">
                            <em class="bx bx-search font-medium-1"></em>
                          </div>
                        </legend>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body card-dashboard">
                  <div class="text-center">
                    <div class="spinner-border text-primary loaderStyle" role="status" v-if="loadingData" style="">
                      <span class="sr-only">{{ $t('common_module_loader_label') }}</span>
                    </div>
                  </div>
                  <div class="text-center mt-1" v-if="!cloOrgUsers.length && !loadingData">
                    <p>{{ $t('common_module_label_users_not_found') }}</p>
                  </div>
                  <div class="table-responsive " v-if="cloOrgUsers.length">
                    <table class="table zero-configuration" aria-describedby="clo org user list">
                      <thead style="border: 1px solid #DFE3E7;">
                      <tr>
                        <th class="tableNames">{{
                            $t('organisation_listing_organisation_table_heading_organisation_name')
                          }}
                        </th>
                        <th class="tableNames">{{
                            $t('organisation_listing_organisation_table_heading_organisation_id')
                          }}
                        </th>
                        <th class="tableNames">{{ $t('organisation_listing_organisation_table_heading_country') }}</th>
                        <th class="tableNames">{{
                            $t('organisation_listing_organisation_table_heading_organization_owner')
                          }}
                        </th>
                        <th class="tableNames">{{ $t('organisation_listing_organisation_table_heading_status') }}</th>
                        <th class="tableNames">{{ $t('organisation_listing_organisation_table_heading_actions') }}</th>
                      </tr>
                      </thead>
                      <tbody style="border: 1px solid #DFE3E7;">
                      <tr v-for="item in cloOrgUsers">
                        <td class="capitalize">
                          <span class=" nameSpan" v-if="item.officialName">{{ item.officialName }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="nameSpan" v-if="item.organizationId">{{ item.organizationId }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                        <span class="nameSpan" v-if="item.currentCountry">{{
                            countryName(item.currentCountry)
                          }}</span>
                          <span class="nameSpan" v-else>-</span>
                        </td>
                        <td>
                          <span class="ml-1" v-if="item.name">{{ item.name }}</span>
                          <span v-else>-</span>
                        </td>
                        <td class="capitalize statusDiv">
                          <span v-if="item.status === 'joined'" style="margin-left: 1em;">
                            <em class="bx bxs-circle success font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_active_status') }}</span>
                          </span>
                          <span v-else-if="item.status === 'invited'" style="margin-left: 1em;">
                            <em class="bx bxs-circle info font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_invite_status') }}</span>
                          </span>
                          <span v-else style="margin-left: 1em;">
                            <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                            <span>{{ $t('users_module_datatable_inactive_status') }}</span>
                          </span>
                        </td>
                        <td>
                          <div class="imageStyle cursor-pointer pl-2">
                            <img :src="viewImage" class=" alignIcon "
                                 :alt="$t('error_message_for_loading_image')"
                                 @click="getCloProfile(item.uid)"
                            >
                            <img v-if="userRole == 'enterpriseadmin'" :src="editImage"
                                 :alt="$t('error_message_for_loading_image')" class="iconEditStyle mr-1 cursor-pointer"
                                 @click="editCloProfile(item.uid)">
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!--    add organisation popup starts-->
    <div
      class="modal fade text-left"
      id="add-organisation-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{
                $t('organisation_add_popup_heading')
              }}</h3>
            <button
              type="button"
              class="close rounded-pill"
              data-dismiss="modal"
              aria-label="Close"
              @click="dialogueClose()"
            >
              <img :src="closeImage" :alt="$t('error_message_for_image')">
            </button>
          </div>
          <div class="modal-body">
            <Alert :text="$t('adding_organisation_id_validation')" type="danger" dismbissable="false"
                   v-if="orgIdValidationError"/>
            <Alert :text="$t('adding_organisation_country_validation')" type="danger" dismbissable="false"
                   v-if="addOrganisationCountryError"/>
            <Alert :text="$t('adding_organisation_name_whole_validation')" type="danger" dismbissable="false"
                   v-if="addOrganisationError"/>
            <Alert :text="$t('adding_organisation_language_whole_validation')" type="danger" dismbissable="false"
                   v-if="addOrganisationLanguageError"/>
            <Alert :text="$t('apiErrorText')" type="danger" dismbissable="false"
                   v-if="apiError"/>
            <form action="#">
              <div class="col-12">
                <label for class="colorLabel">{{ $t('organisation_add_popup_organisation_name_label') }}</label>
                <input type="text" class="form-control height-50 inputRounded"
                       :placeholder="$t('organisation_add_popup_organisation_name_placeholder')"
                       :class="addOrganisationError ? 'errorInput':''" v-model="organisationName"/>
              </div>
              <div class="row ml-0 mt-1 mr-0">
                <div class="col-12">
                  <label for class="colorLabel">{{ $t('organisation_popup_country_label') }}</label>
                  <select class="form-control height-50 inputRounded"
                          :class="addOrganisationCountryError ? 'errorInput':''" v-model="organisationCountry">
                    <option disabled value="default">{{
                        $t('organisation_popup_country_dropdown_default_option')
                      }}
                    </option>
                    <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                        countryName(country)
                      }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row ml-0 mt-1 mr-0">
                <div class="col-12">
                  <label for class="colorLabel">{{ $t('organisation_popup_language_label') }}</label>
                  <select class="form-control height-50 inputRounded"
                          :class="addOrganisationLanguageError ? 'errorInput':''" v-model="organisationLanguage">
                    <option disabled value="default">{{
                        $t('organisation_popup_language_dropdown_default_option')
                      }}
                    </option>
                    <option v-for="(language, index) in totalLanguages" :value="language" :key="index">{{
                        languageName(language)
                      }}
                    </option>
                  </select>
                </div>

              </div>
            </form>

          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-light-secondary"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="dialogueClose">
              <span class="d-none d-sm-block " style="color: white">{{
                  $t('organisation_add_popup_cancel_button')
                }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="addNewOrganisation">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block mr-1 ml-1">{{ $t('organisation_add_popup_add_button') }}</span>
            </button>
          </div>
        </div>
      </div>

    </div>
    <!--    add organisation popup ends-->

    <!--    add organisation confirm popup starts-->
    <div
      class="modal fade text-left"
      id="add-organisation-confirm-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content ">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">
              {{ $t('add_organisation_success_popup_heading') }}</h3>
            <button
              type="button"
              class="close rounded-pill"
              data-dismiss="modal"
              aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_image')">
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
              {{ $t('add_organisation_success_popup_description') }}</h3>
          </div>
          <div class="modal-footer modalFooter">
            <button type="button" class="btn btn-light-secondary"
                    data-dismiss="modal"
                    aria-label="Close">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block " style="color: white">{{
                  $t('organisation_add_popup_cancel_button')
                }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal"
                    aria-label="Close" @click="getCloOrganisationList">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('add_organisation_success_popup_continue_button') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--    add organisation confirm popup ends-->
  </div>
</template>

<script>
import {getCountryName} from "@/app-assets/js/get-countries.js";
import Alert from '@/components/Alerts';
import {getLanguageName} from "@/app-assets/js/get-language.js";

export default {
  name: "CLOListPage",
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      statusFilter: 'default',
      searchByCountryFilter: 'default',
      loadingData: true,
      cloOrgUsers: [],
      viewImage: require('@/assets/Vector.png').default,
      organisationList: true,
      closeImage: require('@/assets/close.png').default,
      editImage: require('@/assets/editing.png').default,
      organisationName: '',
      organisationId: '',
      organisationCountry: 'default',
      totalCountries: [],
      addOrganisationValidationError: false,
      orgIdValidationError: false,
      addOrganisationCountryError: false,
      addOrganisationError: false,
      apiError: false,
      apiErrorText: '',
      userRole: '',
      editable: false,
      organisationLanguage: "default",
      addOrganisationLanguageError: false,
      totalLanguages: []
    }
  },
  components: {
    Alert
  },
  methods: {
    getOrgDetails() {
      console.log("get org details")
      let self = this;
      self.userRole = self.userData.type
    },
    isRequiredValidation() {
      let self = this;
      if (self.organisationName == '') {
        self.addOrganisationError = true;
      } else {
        self.addOrganisationError = false;
        self.orgNameValidation()
      }
      if (self.organisationCountry && self.organisationCountry != 'default') {
        self.addOrganisationCountryError = false;
      } else {
        self.addOrganisationCountryError = true;
      }
      if (self.organisationLanguage && self.organisationLanguage != 'default') {
        self.addOrganisationLanguageError = false;
      } else {
        self.addOrganisationLanguageError = true;
      }
    },
    languageName(element) {
      if (element) {
        return getLanguageName(element);
      }
    },
    addNewOrganisation() {
      let self = this;
      self.isRequiredValidation();
      if (!self.addOrganisationError && !self.addOrganisationCountryError) {
        let data = {
          officialName: self.organisationName,
          currentCountry: self.organisationCountry,
          language: self.organisationLanguage
        }
        this.$apiCall.post(`v1/clo-organization`, data).then((response) => {
          self.organisationName = '';
          self.organisationCountry = 'default';
          $("#add-organisation-modal").modal("hide");
          self.addOrganisationConfirmPopup();

        }).catch((error) => {
          this.apiError = true;
          this.apiErrorText =
            `<strong>Ops!</strong> ${error.response.data.message}`;
        });
      }
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
    getLanguages() {
      console.log(" get languages")
      let self = this;
      this.$apiCall.get(`v1/settings/languages`).then((response) => {
        self.totalLanguages = response.data.dashboardLanguages;
      })
    },
    addOrganisationPopup() {
      $("#add-organisation-modal").modal();
    },
    addOrganisationConfirmPopup() {
      $('#add-organisation-confirm-modal').modal()
    },
    dialogueClose() {
      let self = this;
      self.addOrganisationError = false;
      self.addOrganisationError = false;
      self.addOrganisationCountryError = false;
      self.addOrganisationLanguageError = false;
      self.organisationCountry = 'default';
      self.organisationName = '';
    },
    getCloProfile(id) {
      let self = this;
      self.$router.push({name: 'OrganizationProfilePage', params: {org: id}});
    },
    editCloProfile(id) {
      let self = this;
      self.$router.push({name: 'OrganizationProfilePageEdit', params: {org: id, edit: 'edit'}});
    },
    orgNameValidation() {
      let self = this;
      let orgValidation = /^[a-zA-Z ]*$/g;
      if (orgValidation.test(self.organisationName)) {
        self.addOrganisationError = false;
      } else {
        self.addOrganisationError = true;
      }
    },
    getCloOrganisationList() {
      console.log("inside clo get")
      let self = this;
      self.loadingData = true;
      this.$apiCall.get(`v1/clo-organization`).then((response) => {
        self.loadingData = false;
        self.cloOrgUsers = response.data.data;
        self.initDataTable()
      })
    },
    getCountries() {
      console.log("get countries")
      let self = this;
      self.totalCountries = ['lb', 'jo', 'pl', 'ua', 'us', 'ca', 'pe', 'co']
    },
    initDataTable() {
      let self = this
      setTimeout(function () {
        $('.zero-configuration').DataTable({
          "bLengthChange": false,
          "bFilter": false,
          "order": []
        });
        $.fn.dataTable.ext.errMode = 'none';
      }, 100)
    },
    filterByData() {
      let self = this;
      self.cloOrgUsers = [];
      self.loadingData = true;
      let filterData = {};
      if (self.statusFilter != "default") {
        filterData.status = self.statusFilter;
      }
      if (self.searchByCountryFilter != "default") {
        filterData.currentCountry = self.searchByCountryFilter;
      }
      if (filterData.status || filterData.currentCountry) {
        self.filterApiCall(filterData)
      } else {
        self.cloOrgUsers = []
        self.getCloOrganisationList();
      }
    },
    filterApiCall(data) {
      let self = this;
      self.$apiCall
        .get(`v1/clo-organization`, {params: data})
        .then(response => {
          self.loadingData = false;
          self.cloOrgUsers = response.data.data;
          self.initDataTable();
        })
    },
    getUrlData() {
      console.log("get url data")
      let self = this;
      let path = location.pathname;
      let directories = path.split("/");
      let lastDirecotry = directories[(directories.length - 1)];
      if (lastDirecotry == 'organisation') {
        self.organisationList = true;
      } else {
        self.organisationList = false;
      }
    }
  },

  mounted() {
    this.getUrlData()
    this.getOrgDetails()
    this.getCountries()
    this.getLanguages()
    this.getCloOrganisationList()
  }
}

</script>

<style scoped>
.buttonStyle {
  margin-right: 2em;
}

.titleColor {
  color: #475F7B;
}

.loaderStyle {
  opacity: .6;
}

.tableNames {
  font-size: 1rem
}

.alignIcon {
  margin-top: 1.2em;
  margin-left: 2em;
}

.statusDiv {
  padding: 1.15rem 1rem;
}

.colorLabel {
  color: #767676;
}

.inputRounded {
  border-radius: 6px;
}

.iconEditStyle {
  height: 19px;
  width: 21px;
  cursor: pointer;
  margin-left: 1em;
  margin-top: 1em;
}

.imageStyle {
  margin-top: -1em;
  margin-left: -3em;
}

.errorInput {
  border: solid red 1px
}
</style>
